module.exports = __webpack_public_path__ + "static/media/classic_dream_02.30085b16.png";